import { trpc } from "../lib/trpc.js";

/**
 * Hook de autenticação. Resolve o usuário atual via /trpc/auth.me.
 *
 * `user` é null se não autenticado.
 * `refetch()` deve ser chamado após login/logout para revalidar.
 */
export function useAuth() {
  const meQuery = trpc.auth.me.useQuery(undefined, {
    staleTime: 60_000,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return {
    user: meQuery.data ?? null,
    isLoading: meQuery.isLoading,
    isAuthenticated: !!meQuery.data,
    refetch: meQuery.refetch,
  };
}
